import {
	DeletePipelineOrStageRequest,
	PipelineCreateRequest
} from "@/Contracts/Pipelines/index";
import axios, { AxiosResponse } from "axios";

import {
	getRequest,
	postRequest,
	putRequest
} from "@/Utils/Service/BackendService";
import {
	PipelineListResponse,
	Pipeline,
	ReorderOpportunitiesRequest,
	DeletePipelineOrStageResponse
} from "@/Contracts/Pipelines";

const getPipelineListUrl = "/v2/pipelines";
const getPipelineUrl = "/v2/pipelines/{pipeline_id}";
const reorderPipelineUrl = "/v2/pipelines/reorder/{pipeline_id}";
const deletePipelineOrStageUrl = "/v2/pipelines/async_delete";

export const getPipelines = async (): Promise<PipelineListResponse> => {
	try {
		const response: AxiosResponse<PipelineListResponse> = await axios(
			getRequest(getPipelineListUrl, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const addNewPipeline = async (
	pipelineCreateRequest: PipelineCreateRequest
): Promise<Pipeline> => {
	try {
		const response: AxiosResponse<Pipeline> = await axios(
			postRequest(
				getPipelineListUrl,
				pipelineCreateRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const editPipelines = async (
	pipelineId: string,
	pipeline: Pipeline
): Promise<Pipeline> => {
	try {
		const response: AxiosResponse<Pipeline> = await axios(
			putRequest(
				getPipelineUrl.replace("{pipeline_id}", pipelineId),
				pipeline,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deletePipelineOrStage = async (
	data: DeletePipelineOrStageRequest
): Promise<DeletePipelineOrStageResponse> => {
	try {
		const response: AxiosResponse<DeletePipelineOrStageResponse> =
			await axios(
				postRequest(deletePipelineOrStageUrl, data, true, false, false)
			);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getPipelineDetails = async (
	pipelineId: string
): Promise<Pipeline> => {
	try {
		const response: AxiosResponse<Pipeline> = await axios(
			getRequest(
				getPipelineUrl.replace("{pipeline_id}", pipelineId),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const reorderPipeline = async ({
	opportunityStages,
	pipelineId
}: ReorderOpportunitiesRequest): Promise<Pipeline> => {
	try {
		const response: AxiosResponse<Pipeline> = await axios(
			putRequest(
				reorderPipelineUrl.replace("{pipeline_id}", pipelineId),
				{ opportunity_stages: opportunityStages },
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
